import { render, staticRenderFns } from "./problem-processing-speed.vue?vue&type=template&id=2366ac81&scoped=true"
import script from "./problem-processing-speed.vue?vue&type=script&lang=js"
export * from "./problem-processing-speed.vue?vue&type=script&lang=js"
import style0 from "./problem-processing-speed.vue?vue&type=style&index=0&id=2366ac81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366ac81",
  null
  
)

export default component.exports